// src/services/asistenciasService.js
import { getAuthHeader } from "./authService";

/** Institución fija (dato quemado) */
export const INSTITUCION_ID = "16020324-f0ea-4319-905c-5a30618ce9f5";

/** Base URL del backend */
const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/api/v1/asistencia`;

/* ========== Helpers ========== */
const toJson = (res) => res.json().catch(() => ({}));

const ensureOk = (res, data) => {
  if (!res.ok) {
    const msg =
      data?.message ||
      data?.error ||
      (typeof data === "string" ? data : "") ||
      `HTTP ${res.status}`;
    throw new Error(msg);
  }
};

/**
 * GET - Obtener todas las asistencias de una institución con información completa
 * Endpoint: GET /api/asistencia/all/:contextInstitutionId
 * @returns {Promise<Array>} Lista de asistencias con deportista, evento y usuario
 */
export async function getAllAsistencias() {
  const res = await fetch(`${BASE_URL}/${INSTITUCION_ID}`, {
    headers: { Accept: "application/json", ...getAuthHeader() },
  });
  const data = await toJson(res);
  ensureOk(res, data);
  return data?.data ?? [];
}

/**
 * Constantes para estados de asistencia
 */
export const ESTADOS_ASISTENCIA = {
  PRESENTE: "presente",
  AUSENTE: "ausente",
  TARDANZA: "tardanza",
  JUSTIFICADO: "justificado",
};
